import { createMiddleware } from "@tanstack/react-start";

const PREVIEW_ZONES = [
  "lovableproject.com",
  "lovableproject-dev.com",
  "lovable.app",
  "gpt-eng.com",
  "gptengineer.run",
];

/**
 * True when a session might exist. Anonymous visitors skip this so the
 * Supabase client (auth, realtime, storage) is not downloaded on first paint.
 * Lovable preview frames broker the session outside localStorage, so they load it.
 */
export function shouldAttachSupabaseAuth(): boolean {
  if (typeof window === "undefined") return false;
  const host = location.hostname;
  const onPreview = PREVIEW_ZONES.some((zone) => host === zone || host.endsWith(`.${zone}`));
  if (onPreview && window.parent !== window) return true;
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("sb-") && key.includes("auth-token")) return true;
    }
  } catch {
    return false;
  }
  return false;
}

export const lazySupabaseAuth = createMiddleware({ type: "function" }).client(async ({ next }) => {
  if (!shouldAttachSupabaseAuth()) return next();
  const { supabase } = await import("@/integrations/supabase/client");
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return next({
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
});
